import MainBanners from '@activities/MainActivity/components/MainBanners';
import MainFooter from '@activities/MainActivity/components/MainFooter';
import Header from '@activities/MainActivity/components/MainLayout/Header';
import NavigationBar from '@activities/MainActivity/components/MainLayout/NavigationBar';
import Recommendation from '@activities/MainActivity/components/Recommendation';
import SubBanners from '@activities/MainActivity/components/SubBanners';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';

import UserRewards from './UserRewards';

function Main() {
    return (
        <Container>
            <Header/>
            <Contents data-scroll-restoration={true}>
                <MainBanners/>
                <UserRewards/>
                <SubBanners type='MAIN_2' />
                <SubBanners type='MAIN_3' />
                <Recommendation/>
                <MainFooter/>
            </Contents>
            <NavigationBar/>
            <IndexText color={colors.red} size='3xl' fontWeight='medium'>
                1
            </IndexText>
        </Container>
    );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    position: relative;
    width: 100%;
    background-color: var(--color-gray2);
    pointer-events: none;
`;

const Contents = styled.main`
    flex: 1;
    overflow-y: hidden;
    padding-top: 32px;
`;

const IndexText = styled(Text)`
    position: absolute;
    left: 8px;
    top: calc(16px + var(--safe-area-top));
`;
export default Main;
